import React from 'react';
// import Link from 'react-router-dom/Link';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Link from '../Link';
import Img from '../Img';
import OutboundLink from '../OutboundLink';
import DesktopGrid from '../DesktopGrid';
import { AppStoreButton, PlayStoreButton } from '../AppDownloadButtons';
import styles from './styles.sass';

export default function Footer({
  children,
  campaign,
  isLoggedIn,
  isAmp = false,
}) {
  return (
    <footer className={styles.footer}>
      {children}
      <DesktopGrid fillHeight={false}>
        <Row>
          <Col xs={12} sm={2} smPush={3}>
            <ul>
              <li>Anchor</li>
              <li>
                <Link to="/about">ABOUT</Link>
              </li>
              <li>
                <Link to="/features">FEATURES</Link>
              </li>
              <li>
                <Link to="/jobs">JOBS</Link>
              </li>
              <li>
                <OutboundLink to="https://help.anchor.fm/">HELP</OutboundLink>
              </li>
              <li>
                <OutboundLink to="https://anch.co/anchor-community-guidelines">
                  COMMUNITY GUIDELINES
                </OutboundLink>
              </li>
              <li>
                <Link to="/how-to-start-a-podcast">HOW TO START A PODCAST</Link>
              </li>
            </ul>
          </Col>
          <Col xs={12} sm={2} smPush={3}>
            <ul>
              <li>Social</li>
              <li>
                <OutboundLink to="http://twitter.com/anchor" newWindow>
                  TWITTER
                </OutboundLink>
              </li>
              <li>
                <OutboundLink
                  to="https://www.facebook.com/anchor.fm/"
                  newWindow
                >
                  FACEBOOK
                </OutboundLink>
              </li>
              <li>
                <OutboundLink to="https://instagram.com/anchor.fm" newWindow>
                  INSTAGRAM
                </OutboundLink>
              </li>
              <li>
                <OutboundLink to="https://www.youtube.com/anchorfm" newWindow>
                  YOUTUBE
                </OutboundLink>
              </li>
            </ul>
          </Col>
          <Col xs={12} sm={2} smPush={3}>
            <ul>
              <li>Legal</li>
              <li>
                <Link to="/tos">TERMS</Link>
              </li>
              {isLoggedIn ? (
                <li>
                  <Link to="/tos/monetization">MONETIZATION TERMS</Link>
                </li>
              ) : null}
              <li>
                <Link to="/privacy">PRIVACY POLICY</Link>
              </li>
              <li>
                <Link to="/dmca">DMCA</Link>
              </li>
            </ul>
          </Col>
          <Col
            className={`${styles.footerLogo} col-sm-3 col-xs-12 col-sm-pull-6`}
          >
            <Link to="/">
              <Img
                isAmp={isAmp}
                src="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4@2x.png 2x"
                alt="Anchor Podcasts"
                height={55}
                width={219}
                layout="responsive"
              />
            </Link>
            <p className={styles.copyright}>
              2018 &copy; Anchor FM Inc. All Rights Reserved
            </p>
          </Col>
          <Col className={`${styles.footerDownloads} col-sm-3 hidden-xs`}>
            <div className={styles.appStoreButton}>
              <AppStoreButton width={181} />
            </div>
            <div className={styles.playStoreButton}>
              <PlayStoreButton width={181} />
            </div>
          </Col>
        </Row>
      </DesktopGrid>
    </footer>
  );
}
